import { Howl, HowlOptions } from "howler"
const swing = require("../../assets/audio/battle/swing.wav")
const button = require("../../assets/audio/ui/click5.ogg")
const mainBg = require("../../assets/audio/music/bgScene.mp3")
const fightBg = require("../../assets/audio/music/Heresy.mp3")
const openChest = require("../../assets/audio/battle/door.wav")
const potion = require("../../assets/audio/battle/bottle.wav")
const armor = require("../../assets/audio/battle/armor-light.wav")
const weapon = require("../../assets/audio/battle/sword-unsheathe.wav")
const coin = require("../../assets/audio/battle/coin.wav")
const death = require("../../assets/audio/battle/death.wav")
const boss = require("../../assets/audio/music/bossMusic.mp3")
const magic = require("../../assets/audio/battle/Magic.mp3")
const damageDeal = require("../../assets/audio/battle/damage_1_sean.wav")
const greeting = require("../../assets/audio/character/greeting_1_alex.wav")
const getDamage = require("../../assets/audio/battle/grunting_1_sean.wav")

export type TSound =
    "mainMusic" |
    "fightMusic" | 
    "bossMusic" | 
    "potion" | 
    "armor" | 
    "weapon" | 
    "coin" | 
    "death" |
    "damageDeal" |
    "greeting" |
    "magic" |
    "getDamage" |
    "chest" |
    "button" |
    "swing" |
    HowlOptions

const mainBgMusic = new Howl({
    src: mainBg,
    loop: true
})

const buttonSound = new Howl({
    src: button
})

const swingSound = new Howl({
    src: swing
})

const fightBgMusic = new Howl({
    src: fightBg,
    loop: true
})

const bossMusic = new Howl({
    src: boss,
    loop: true
})

const openChestSound = new Howl({
    src: openChest
})

const potionSound = new Howl({
    src: potion
})

const armorSound = new Howl({
    src: armor
})

const weaponSound = new Howl({
    src: weapon
})

const coinSound = new Howl({
    src: coin
})

const deathSound = new Howl({
    src: death
})

const damageDealSound = new Howl({
    src: damageDeal
})

const greetingSound = new Howl({
    src: greeting
})

const magicSound = new Howl({
    src: magic,
    volume: 0.3
})

const getDamageSound = new Howl({
    src: getDamage
})

function getSound(soundName: TSound) {
    switch(soundName) {
        case "mainMusic":
            return mainBgMusic
        case "armor":
            return armorSound
        case "bossMusic":
            return bossMusic
        case "coin":
            return coinSound
        case "damageDeal":
            return damageDealSound
        case "death":
            return deathSound
        case "fightMusic":
            return fightBgMusic
        case "getDamage":
            return getDamageSound
        case "greeting":
            return greetingSound
        case "magic":
            return magicSound
        case "potion":
            return potionSound
        case "weapon":
            return weaponSound
        case "chest":
            return openChestSound
        case "button":
            return buttonSound
        case "swing":
            return swingSound
        default: 
            return new Howl(soundName)
    }
}

export function soundToPlay(sound: TSound) {
    getSound(sound).play()
}

export function soundToStop(sound: TSound) {
    getSound(sound).stop()
}

export function stopAllSounds() {
    mainBgMusic.stop()
    armorSound.stop()
    bossMusic.stop()
    coinSound.stop()
    damageDealSound.stop()
    deathSound.stop()
    fightBgMusic.stop()
    getDamageSound.stop()
    greetingSound.stop()
    magicSound.stop()
    potionSound.stop()
    weaponSound.stop()
    openChestSound.stop()
    buttonSound.stop()
    swingSound.stop()
}